import React, { Component } from 'react'
import { connect } from 'react-redux'
import Checkmark from '../Checkmark/Checkmark'

class PaymentSummary extends Component {
  render() {
    const { payment } = this.props
    console.log({ payment })

    // Not all appointments require payment
    if (payment === null) {
      return null
    }

    return (
      <div className="payment-result">
        <Checkmark />
        Thank you, your payment is approved.
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  payment: state.payment,
})
export default connect(mapStateToProps)(PaymentSummary)
